<template>
  <v-card
    elevation="10"
    class="mx-auto"
    min-height="740"
    style="
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    "
  >
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="12">
          <v-row class="mt-2 pt-2 pl-3 pr-3">
            <v-select
              item-disabled="disable"
              __dense
              item-text="name"
              :items="documents"
              :label="filesLabel"
              :append-icon="!isMobile ? 'mdi-chevron-down-circle' : undefined"
              :class="{
                'files-label-emphasis big-select-icon': !isMobile,
                'files-label-loading': !isMobile && isLoadingFilesLabel,
              }"
              return-object
              v-model="selectedFile"
            ></v-select>
            <v-tooltip v-if="getDocErrorFlag" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2 mr-2"
                  large
                  color="warning"
                >
                  mdi-alert
                </v-icon>
              </template>
              <span> {{ $t('missingDocWarning') }}</span>
            </v-tooltip>
            <v-dialog transition="dialog-bottom-transition" max-width="1300">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" v-if="!isMobile">
                  <v-icon>mdi-arrow-expand-all</v-icon>
                </v-btn>
              </template>
              <template v-slot:default="dialog">
                <v-card min-height="780" max-height="90%">
                  <v-toolbar color="primary" dark>
                    <v-row align="center">
                      <v-col cols="10">
                        <h3>
                          {{ $t('notificationFiles') }}
                        </h3>
                      </v-col>
                      <v-col cols="2" class="d-flex justify-end">
                        <v-btn @click="dialog.value = false" icon>
                          <v-icon>mdi-window-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                    style="
                      height: 748px;
                      overflow-y: scroll;
                      overflow-x: hidden;
                    "
                    align="center"
                  >
                    <v-row class="mt-2 d-flex justify-center">
                      <v-select
                        item-disabled="disable"
                        __dense
                        item-text="name"
                        :items="documents"
                        :label="filesLabel"
                        :append-icon="
                          !isMobile ? 'mdi-chevron-down-circle' : undefined
                        "
                        :class="{
                          'mt-5 files-label-emphasis big-select-icon':
                            !isMobile,
                        }"
                        return-object
                        v-model="selectedFile"
                        style="max-width: 80%"
                      ></v-select>
                      <v-tooltip v-if="getDocErrorFlag" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            class="ml-2 mr-2"
                            large
                            color="warning"
                          >
                            mdi-alert
                          </v-icon>
                        </template>
                        <span> {{ $t('missingDocWarning') }}</span>
                      </v-tooltip>
                    </v-row>
                    <v-col v-if="loadingData" class="ma-0" cols="12" sm="12">
                      <v-progress-linear indeterminate color="primary">
                      </v-progress-linear>
                    </v-col>
                    <v-col
                      __class="pa-0 ma-0"
                      cols="12"
                      style="height: 568px; overflow-y: scroll"
                    >
                      <DehuDocumentViewer
                        v-if="selectedFile.file"
                        :blob="selectedFile.file"
                        :contentType="selectedFile.contentType"
                        :rtfString="selectedFile.rtfString"
                        @embedded-files="handleEmbeddedFiles"
                      />
                    </v-col>
                  </v-col>
                  <v-card-actions>
                    <v-row
                      v-if="!isMobile"
                      no-gutters
                      class="flex-wrap"
                      justify="center"
                    >
                      <v-btn
                        v-if="
                          isSharedAccess
                            ? true
                            : !isOperatorUser ||
                              $store.state.user?.processNotification
                        "
                        :disabled="!Object.keys(selectedFile).length"
                        @click="downloadSelectedFile()"
                        color="primary"
                        class="ma-2 secondary--text"
                      >
                        {{ $t('downloadFile') }}
                        <v-icon right dark> mdi-file-download-outline </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          isSharedAccess
                            ? true
                            : !isOperatorUser ||
                              $store.state.user?.processNotification
                        "
                        :disabled="!Object.keys(selectedFile).length"
                        @click="downloadSelectedFile()"
                        color="primary"
                        class="ma-2 secondary--text"
                      >
                        {{ $t('downloadFile') }}
                        <v-icon right dark> mdi-file-download-outline </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          isSharedAccess
                            ? true
                            : !isOperatorUser ||
                              $store.state.user?.processNotification
                        "
                        :disabled="
                          loadingData ||
                          !documents.filter((o) => o?.disable === false).length
                        "
                        @click="downloadAllFiles()"
                        color="primary"
                        class="ma-2 secondary--text"
                      >
                        {{ $t('downloadAll') }}
                        <v-icon right dark>
                          mdi-folder-arrow-down-outline
                        </v-icon>
                      </v-btn>
                    </v-row>
                    <v-col align="center" v-else>
                      <v-btn
                        v-if="
                          isSharedAccess
                            ? true
                            : !isOperatorUser ||
                              $store.state.user?.processNotification
                        "
                        :disabled="!Object.keys(selectedFile).length"
                        @click="downloadSelectedFile()"
                        color="primary"
                        class="ma-2 secondary--text"
                      >
                        {{ $t('downloadFile') }}
                        <v-icon right dark> mdi-file-download-outline </v-icon>
                      </v-btn>
                      <v-btn
                        v-if="
                          isSharedAccess
                            ? true
                            : !isOperatorUser ||
                              $store.state.user?.processNotification
                        "
                        :disabled="
                          loadingData ||
                          !documents.filter((o) => o?.disable === false).length
                        "
                        @click="downloadAllFiles()"
                        color="primary"
                        class="ma-2 secondary--text"
                      >
                        {{ $t('downloadAll') }}
                        <v-icon right dark>
                          mdi-folder-arrow-down-outline
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-row>
        </v-col>
        <v-col v-if="loadingData" class="ma-0" cols="12" sm="12">
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-col>
        <v-col
          class="pa-0 ma-0"
          cols="12"
          style="height: 568px; overflow-y: scroll"
        >
          <DehuDocumentViewer
            v-if="selectedFile.file"
            :blob="selectedFile.file"
            :contentType="selectedFile.contentType"
            :rtfString="selectedFile.rtfString"
            @embedded-files="handleEmbeddedFiles"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <component
        :is="isMobile ? 'v-col' : 'v-row'"
        :no-gutters="!isMobile"
        :class="!isMobile ? 'flex-wrap' : ''"
        justify="center"
        align="center"
      >
        <v-dialog persistent v-model="addFilesDialog" width="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                isSharedAccess || $store.getters.isDemoEnv
                  ? false
                  : !isOperatorUser || $store.state.user?.processNotification
              "
              v-bind="attrs"
              v-on="on"
              @click="shareDialog = true"
              color="green"
              class="ma-2 secondary--text"
              :disabled="
                loadingData ||
                !documents.filter((o) => o?.disable === false).length
              "
            >
              {{ $t('addFile') }}
              <v-icon right dark> mdi-plus </v-icon>
            </v-btn>
          </template>

          <v-card
            v-if="!isOperatorUser || $store.state.user?.processNotification"
          >
            <v-card-title class="text-h5 grey lighten-2">
              <v-container>
                <v-row justify="space-between" align="center">
                  <span>
                    {{
                      isMobile
                        ? $t('addNotificationFilesMobile')
                        : $t('addNotificationFiles')
                    }}
                  </span>
                  <v-btn
                    fab
                    @click="addFilesDialog = false"
                    small
                    plain
                    v-if="!loadingDataDialog"
                  >
                    <v-icon> mdi-close </v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-card-title>
            <v-col class="pt-5" cols="12" justify="center" align="center">
              <NotificationAttachedFiles
                @update-files-attached="updateFilesAttached"
                :alreadyUploadedFiles="notification.documentExtras"
                :applyRules="true"
                :openOnInit="openOnInit"
                :key="renderAgain"
                :notificationId="notification.id"
              />
            </v-col>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="confirmUploadExtraFiles()"
                color="primary"
                text
                id="confirm-upload-files"
                :loading="loadingDataDialog"
                :disabled="!filesAttached.length"
              >
                {{ $t('confirm') }}
                <template v-slot:loader>
                  <v-progress-circular indeterminate size="20" width="2" />
                </template>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          v-if="
            isSharedAccess
              ? true
              : !isOperatorUser || $store.state.user?.processNotification
          "
          :disabled="!Object.keys(selectedFile).length"
          @click="downloadSelectedFile()"
          color="primary"
          class="ma-2 secondary--text"
        >
          {{ $t('downloadFile') }}
          <v-icon right dark> mdi-file-download-outline </v-icon>
        </v-btn>
        <v-btn
          v-if="
            isSharedAccess
              ? true
              : !isOperatorUser || $store.state.user?.processNotification
          "
          :disabled="
            loadingData || !documents.filter((o) => o?.disable === false).length
          "
          @click="downloadAllFiles()"
          color="primary"
          class="ma-2 secondary--text"
        >
          {{ $t('downloadAll') }}
          <v-icon right dark> mdi-folder-arrow-down-outline </v-icon>
        </v-btn>
      </component>
    </v-card-actions>
  </v-card>
</template>

<script>
import DehuDocumentViewer from '@/components/commons/DehuDocumentViewer'
import NotificationAttachedFiles from '@/components/notifications/detail/NotificationAttachedFiles'
import { saveAs } from 'file-saver'
import { mapGetters, mapMutations } from 'vuex'
import {
  getNotificationType,
  openAnnexe,
  openNotification,
  openAck,
  openExtra,
  uploadAddedDocumentsToDMS,
} from '@/services/notification-service'
import {
  demoDocumentBase64,
  demoAckBase64,
  demoAnnexeBase64,
} from '@/services/notification-demo-service'
import { VRow, VCol } from 'vuetify/lib'

const mime = require('mime-types')
const lodash = require('lodash')

export default {
  props: {
    notification: Object,
    isSharedAccess: Boolean,
  },
  components: {
    DehuDocumentViewer,
    NotificationAttachedFiles,
    VRow,
    VCol,
  },
  watch: {
    notification: function (newNotification, oldNotification) {
      if (!newNotification.document) return
      // Modificar esta condicion porque hace que no se recargue con los ficheros extra añadidos por el usuario
      if (
        lodash.isEqual(newNotification.document, oldNotification.document) &&
        lodash.isEqual(
          newNotification.documentExtras,
          oldNotification.documentExtras
        )
      )
        return

      this.getDocuments(this.notification)
      // Re-renderizamos el compoente NotificationAttachedFiles
      this.openOnInit = false
      this.renderAgain += 1
    },
    loadingData(val) {
      // Al terminar de cargar los ficheros del detalle, mostramos el primer
      // documento embebido de una cartera PDF que se haya añadido al selector.
      if (!val && this.pendingEmbeddedDoc) {
        this.selectedFile = this.pendingEmbeddedDoc
        this.pendingEmbeddedDoc = null
      }
    },
  },
  mounted() {
    this.documents = []
    this.getDocuments(this.notification)
  },
  data() {
    return {
      documents: [],
      loadingData: false,
      loadingDataDialog: false,
      selectedFile: {},
      getDocErrorFlag: false,
      addFilesDialog: false,
      filesAttached: [],
      renderAgain: 0,
      openOnInit: true,
      documentsToDelete: [],
      pendingEmbeddedDoc: null,
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'isOperatorUser']),
    filesLabel() {
      const count = this.documents?.length ?? 0
      return this.loadingData && count === 0
        ? this.$t('loadingFiles')
        : count === 0
        ? this.$t('noFiles')
        : count === 1
        ? this.$t('fileSingle', { count })
        : this.$t('filesWithCount', { count })
    },
    isLoadingFilesLabel() {
      return this.loadingData && (this.documents?.length ?? 0) === 0
    },
  },
  methods: {
    ...mapMutations(['setSnackbar']),
    async updateFilesAttached(newFilesAttached) {
      this.filesAttached = []
      this.documents = []
      const extraFiles = newFilesAttached.filter(
        (document) =>
          (document.alreadyUploadedToDMS === false ||
            document.addedDocument === false) &&
          !document.simpleDelete &&
          !document.deleteFromDMS
      )

      // Solo añadimos aquellos que no han sido añadidos previamente
      if (extraFiles.length !== 0)
        extraFiles.forEach((file) => {
          if (
            !this.filesAttached.some(
              (existingFile) => existingFile.name === file.name
            )
          ) {
            this.filesAttached.push(file)
          }
        })
    },
    async confirmUploadExtraFiles() {
      try {
        if (!this.filesAttached.length) return
        if (
          this.filesAttached.every((file) =>
            this.notification.documentExtras?.some(
              (document) => document.name === file.name
            )
          )
        ) {
          const message = this.$t('extraFilesUpdateSuccess')
          this.setSnackbar({ position: 'top', type: 'success', message })
          this.addFilesDialog = false
          return
        }
        this.loadingDataDialog = true

        await uploadAddedDocumentsToDMS(this.notification.id, {
          documents: this.filesAttached,
        })

        this.documents = []
        this.documentsToDelete = []
        this.loadingDataDialog = false

        // Mostramos snackbar con el mensaje de exito
        const message = this.$t('extraFilesUpdateSuccess')
        this.setSnackbar({ position: 'top', type: 'success', message })
        this.addFilesDialog = false
      } catch (err) {
        this.loadingDataDialog = false
        const message = this.$t('extraFilesUpdateError')
        this.setSnackbar({
          position: 'top',
          type: 'error',
          message,
        })
        return
      }
    },
    async getDocuments(notification) {
      this.loadingData = true
      this.documents = []
      //get all docs converted into blob from dehu base64 string codification to be displayed in visor component
      if (notification.document.items) {
        for (const doc of notification.document.items) {
          try {
            const mainDoc = await this.getMainDoc(notification, doc)
            this.documents.push(mainDoc)

            // optimización: mostrar al usuario el primer documento, si está enabled, en cuanto
            // este descargado, sin esperar a descargarlos todos para mostrarlo.
            if (
              !this.selectedFile &&
              this.documents.length === 1 &&
              this.documents[0]?.disable === false
            ) {
              this.selectedFile = this.documents[0]
            }
          } catch (error) {
            this.documents.push({
              contentType: 'application/pdf',
              name: `📄 Documento_${doc['#Id']}.pdf`,
              name_dehu: `Documento_${doc['#Id']}.pdf`,
              disable: true,
            })
            //console.log('Error Al obtener documento principal', error)
            this.getDocErrorFlag = true
          }
        }
      }
      this.selectedFile = this.documents.filter((o) => o?.disable === false)[0] //Use the first enable element as selectedFile
      if (!this.selectedFile) this.selectedFile = {}

      // Anexos ----------------------------------------------------
      //get all documents, content
      if (notification.document.referenciaAnexos) {
        for (const annexe of notification.document.referenciaAnexos) {
          try {
            const openedAnnexe = await this.getAnnexeDoc(notification, annexe)
            this.documents.push(openedAnnexe)
          } catch (error) {
            this.documents.push({
              name: '🖇️' + annexe.nombre,
              name_dehu: annexe.nombre,
              disable: true,
            })
            //console.log('Error al obtener anexo:', annexe, error)
            this.getDocErrorFlag = true
          }
        }
      }

      /// Acuse de recibo, Ack --------------------------------------
      if (
        getNotificationType(notification).name == 'notification' &&
        (notification.document.csv_resguardo ||
          notification.document.referencia_pdf_acuse)
      ) {
        try {
          const openedAck = await this.getAckDoc(notification)
          this.documents.push(openedAck)
        } catch (error) {
          this.documents.push({
            name: `🧾 Acuse_${notification.id}.pdf`,
            disable: true,
          })
          //console.log('Error al obtener acuse de recibo:', error)
          this.getDocErrorFlag = true
        }
      }

      // Documentos extra ------------------------------------------
      if (notification.documentExtras) {
        for (const extra of notification.documentExtras) {
          let contentType = ''
          if (extra.name.endsWith('.pdf')) {
            contentType = 'application/pdf'
          } else if (extra.name.endsWith('.zip')) {
            contentType = 'application/x-zip-compressed'
          } else if (extra.name.endsWith('.rtf')) {
            contentType = 'text/richtext'
          }
          try {
            const openedExtra = {
              file: new Blob(
                [
                  Buffer.from(
                    await openExtra(
                      notification,
                      extra,
                      this.isSharedAccess
                        ? {
                            userId: this.$route.params.userId,
                            shareCode: this.$route.params.shareCode,
                          }
                        : undefined
                    ),
                    'base64'
                  ),
                ],
                {
                  type: contentType,
                }
              ),
              contentType: contentType,
              rtfString: undefined,
              name: '➕' + extra.name,
              name_dehu: extra.name,
              disable: false,
            }
            this.documents.push(openedExtra)
          } catch (error) {
            this.documents.push({
              name: '➕' + extra.name,
              name_dehu: extra.name,
              disable: true,
            })
            //console.log('Error al obtener extra:', extra, error)
            this.getDocErrorFlag = true
          }
        }
      }

      this.loadingData = false
    },
    /**
     * Añade al selector de ficheros los documentos embebidos de una cartera PDF
     * (PDF Portfolio), ya que pdf.js no puede representar la cartera completa.
     */
    handleEmbeddedFiles(embeddedFiles) {
      if (!embeddedFiles?.length) return

      const added = []
      embeddedFiles.forEach((embedded) => {
        // Evitamos duplicados si la cartera se vuelve a seleccionar
        if (this.documents.some((doc) => doc.name_dehu === embedded.name))
          return
        const embeddedDoc = {
          file: embedded.blob,
          contentType: embedded.contentType,
          rtfString: undefined,
          name: `📄 ${embedded.name}`,
          name_dehu: embedded.name,
          disable: false,
        }
        this.documents.push(embeddedDoc)
        added.push(embeddedDoc)
      })

      if (!added.length) return

      // Mostramos el primero de los documentos embebidos recién añadidos. Si el
      // listado aún se está cargando, esperamos a que termine para no pisar la
      // selección por defecto que hace getDocuments.
      if (this.loadingData) this.pendingEmbeddedDoc = added[0]
      else this.selectedFile = added[0]
    },
    async downloadAllFiles() {
      try {
        this.loadingData = true
        this.documents.forEach((element) => {
          if (element.file) {
            saveAs(element.file, `${element.name_dehu}`)
          }
        })
        this.loadingData = false
      } catch (err) {
        this.loadingData = false
        /*
        const message = getErrorText(err.toString())
        this.setSnackbar({
          position: 'top',
          type: "error"
          message,
        })
        */
      }
    },
    async downloadSelectedFile() {
      try {
        this.loadingData = true
        if (this.selectedFile.file) {
          saveAs(this.selectedFile.file, `${this.selectedFile.name_dehu}`)
        }
        this.loadingData = false
      } catch (err) {
        this.loadingData = false
        /*
        const message = getErrorText(err.toString())
        this.setSnackbar({
          position: 'top',
          type: "error"
          message,
        })
        */
      }
    },
    async getMainDoc(notification, doc) {
      var file
      var rtfString = ''
      if (this.$store.getters.isDemoEnv) {
        file = new Blob([Buffer.from(demoDocumentBase64(), 'base64')], {
          type: 'application/pdf',
        })
        let contentType = 'application/pdf'
        let extension = mime.extension(contentType)
        return {
          file: file,
          contentType: contentType,
          rtfString: '',
          name: `📄 Documento_${doc['#Id']}.${extension}`,
          name_dehu: `Documento_${doc['#Id']}.${extension}`,
          disable: false,
        }
      } else {
        const response = await openNotification(
          notification,
          doc,
          this.isSharedAccess
            ? {
                userId: this.$route.params.userId,
                shareCode: this.$route.params.shareCode,
              }
            : undefined
        )
        const contentType = response.contentType || 'application/pdf'
        const mimeType = response.mimeType ?? ''
        const filename = response.filename ?? ''
        file = new Blob([Buffer.from(response.data, 'base64')], {
          type: contentType,
        })

        // Obtener la extensión usando la librería mime
        let extension
        if (contentType == 'application/x-zip-compressed') {
          extension = 'zip'
        } else {
          extension = mime.extension(contentType)
        }

        if (this.isRtf(contentType)) {
          extension = 'rtf' // Sobrescribir 'rtx' por 'rtf' que es lo que parece ser que usan los clientes en sus zip
        }

        if (this.isRtf(contentType)) {
          // decodificar
          rtfString = atob(response.data)
        }

        return {
          file: file,
          contentType: contentType,
          mimeType: mimeType,
          filename: filename,
          rtfString: rtfString,
          //name: `📄 Documento_${doc['#Id']}.${extension}`,
          name: this.isFilenameEqualsToId(notification, filename)
            ? `📄 Documento_${doc['#Id']}.${extension}`
            : `📄 ${filename}`,
          //name_dehu: `Documento_${doc['#Id']}.${extension}`,
          name_dehu: this.isFilenameEqualsToId(notification, filename)
            ? `Documento_${doc['#Id']}.${extension}`
            : filename,
          disable: false,
        }
      }
    },
    async getAnnexeDoc(notification, doc) {
      var file
      var rtfString = ''
      if (this.$store.getters.isDemoEnv) {
        file = new Blob([Buffer.from(demoAnnexeBase64(), 'base64')], {
          type: 'application/pdf',
        })
        return {
          file: file,
          contentType: 'application/pdf',
          rtfString: '',
          mimeType: 'application/pdf',
          filename: doc.nombre,
          name: '🖇️' + doc.nombre,
          name_dehu: doc.nombre,
          disable: false,
        }
      } else {
        const response = await openAnnexe(
          notification,
          doc,
          this.isSharedAccess
            ? {
                userId: this.$route.params.userId,
                shareCode: this.$route.params.shareCode,
              }
            : undefined
        )
        const contentType = response.contentType || 'application/pdf'
        const mimeType = response.mimeType ?? ''
        const filename = response.filename ?? ''
        file = new Blob([Buffer.from(response.data, 'base64')], {
          type: contentType,
        })

        // Obtener la extensión usando la librería mime
        let extension
        extension = mime.extension(contentType)

        if (this.isRtf(contentType)) {
          extension = 'rtf' // Sobrescribir 'rtx' por 'rtf' que es lo que parece ser que usan los clientes en sus zip
        }

        if (this.isRtf(contentType)) {
          // decodificar
          rtfString = atob(response.data)
        }

        return {
          file: file,
          contentType: contentType,
          mimeType: mimeType,
          filename: filename,
          rtfString: rtfString,
          //name: '🖇️' + annexe.nombre,
          name: this.isFilenameEqualsToId(notification, filename)
            ? `🖇️ Anexo_${doc['#Id']}.${extension}`
            : `🖇️ ${filename}`,
          //name_dehu: annexe.nombre,
          name_dehu: this.isFilenameEqualsToId(notification, filename)
            ? `Anexo_${doc['#Id']}.${extension}`
            : filename,
          disable: false,
        }
      }
    },
    async getAckDoc(notification) {
      var file
      var rtfString = ''
      if (this.$store.getters.isDemoEnv) {
        file = new Blob([Buffer.from(demoAckBase64(), 'base64')], {
          type: 'application/pdf',
        })
        return {
          file: file,
          contentType: 'application/pdf',
          mimeType: 'application/pdf',
          filename: 'acuse.pdf',
          rtfString: '',
          name: `🧾 Acuse_${notification.id}.pdf`,
          name_dehu: `Acuse_${notification.id}.pdf`,
          disable: false,
        }
      } else {
        const response = await openAck(
          notification,
          this.isSharedAccess
            ? {
                userId: this.$route.params.userId,
                shareCode: this.$route.params.shareCode,
              }
            : undefined
        )
        const contentType = response.contentType || 'application/pdf'
        const mimeType = response.mimeType ?? ''
        const filename = response.filename ?? ''
        file = new Blob([Buffer.from(response.data, 'base64')], {
          type: contentType,
        })

        return {
          file: file,
          contentType: contentType,
          mimeType: mimeType,
          filename: filename,
          rtfString: rtfString,
          //name: `🧾 Acuse_${notification.id}.pdf`,
          name: this.isFilenameEqualsToId(notification, filename)
            ? `🧾 Acuse_${notification.id}.pdf`
            : `🧾 ${filename}`,
          //name_dehu: `Acuse_${notification.id}.pdf`,
          name_dehu: this.isFilenameEqualsToId(notification, filename)
            ? `Acuse_${notification.id}.pdf`
            : filename,
          disable: false,
        }
      }
    },
    isRtf(contentType) {
      return (
        contentType === 'text/richtext' || contentType === 'application/rtf'
      )
    },
    isFilenameEqualsToId(notification, filename) {
      if (!notification || !notification.document) return false

      let ids = []
      // Documentos principales
      if (notification.document.items) {
        for (const doc of notification.document.items) {
          ids.push(doc['#Id'])
        }
      }

      // Anexos
      if (notification.document.referenciaAnexos) {
        for (const doc of notification.document.referenciaAnexos) {
          ids.push(doc['#Id'])
        }
      }

      // Ack, si tiene
      if (notification.document.ackId) {
        ids.push(notification.document.ackId)
      }

      // Comprueba si el nombre del fichero comienza por alguno de los ids
      return ids.some((id) => filename.startsWith(id))
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .files-label-emphasis .v-label {
  font-weight: 800; // letra en negrita
  font-size: 1.5rem; // letra mas grande
  color: var(--v-primary-base); // color primary desde el inicio
}

::v-deep .files-label-loading .v-label {
  font-size: 1rem; // tamaño normal por defecto (loading)
}

/* Icono del selector */
::v-deep .big-select-icon .v-input__append-inner .v-icon {
  margin-bottom: 8px;
  font-size: 32px;
  color: var(--v-primary-base); // icono color primary desde el inicio
}
</style>
